/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Center, Container, Flex, Text } from '@chakra-ui/react';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/km';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import BreadcrumbComponent from '../../../components/BreadcrumbComponent/BreadcrumbComponent';
import GeneralQuarterlyClaimDetail from '../../../components/MarketDevelopment/QuarterlyClaim/General/page';
import LifeQuarterlyClaimDetail from '../../../components/MarketDevelopment/QuarterlyClaim/Life/page';
import MicroQuarterlyClaimDetail from '../../../components/MarketDevelopment/QuarterlyClaim/Micro/page';
import PrintLayout from '../../../components/Print/PrintLayout';
import c from '../../../constant';
import useStore from '../../../store';
import composeQueries from '../../../utils/composeQueries';
import { getReportTitle } from '../Utils';

export default function QuarterlyClaimReportDetail({ detailReportId = null, detailReportType = null }) {
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const id = urlParams.get('id') ?? detailReportId;
	const reportType = urlParams.get('reportType') ?? detailReportType;
	const period = urlParams.get('period') ?? null;
	const reportId = urlParams.get('reportId') ?? null;
	const companyType = urlParams.get('companyType') ?? null;
	const companyId = urlParams.get('companyId') ?? null;
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state.currentLang);

	useEffect(() => moment.locale(lang === 'kh' ? 'km' : 'en-gb'), [lang]);

	function SpreadSheet() {
		return (
			<>
				{reportType === 'General' && (
					<>
						<GeneralQuarterlyClaimDetail id={id} />
					</>
				)}
				{reportType === 'Life' && (
					<>
						<LifeQuarterlyClaimDetail id={id} />
					</>
				)}
				{reportType === 'Micro' && (
					<>
						<MicroQuarterlyClaimDetail id={id} />
					</>
				)}
			</>
		);
	}

	return (
		<PrintLayout>
			<>
				<Container maxW="container.xl" mt="16px" mb="16px">
					{!(detailReportId && detailReportType) && (
						<BreadcrumbComponent
							list={[
								{
									name: 'Insurance Institute Report',
									path: '/company-submission-report',
								},
								{
									name: period,
									path: '/company-submission-report?period=' + period,
								},
								{
									name: getReportTitle(reportId),
									path: composeQueries('/market-development-data?period=' + period + '&reportId=' + reportId, { companyType, companyId }),
								},
								{
									name: 'Detail',
									path: '#',
								},
							]}
						/>
					)}
					<Center mt="5">
						<Box
							w="100%"
							bg="white"
							borderRadius={c.borderRadius}
							border="1px solid #dbdbdb"
							boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
							pb={4}
						>
							<Flex
								className="hidden-print responsive-header-for-table"
								bg="#FAFAFA"
								p="16px"
								pt="8px"
								pb="8px"
								mb="16px"
								alignItems="center"
								justifyContent="space-between"
								borderBottom="1px solid #dbdbdb"
							>
								<Text fontSize="x-large" fontWeight="bold">
									{t('Receiving and Settling Claim Report for Insurance Company')}
								</Text>
								<Flex>
									<></>
								</Flex>
							</Flex>
							<SpreadSheet />
						</Box>
					</Center>
				</Container>
			</>
		</PrintLayout>
	);
}
